import type { AlunoOutputType, MateriaOutputType } from '@shared/dto';

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { AlunoForm } from './aluno-form';

export function AlunoFormDialog({
  open,
  onOpenChange,
  aluno,
  materias,
  onSalvo,
  onPainelAtualizado,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  aluno?: AlunoOutputType;
  materias: MateriaOutputType[];
  onSalvo: () => void;
  onPainelAtualizado?: () => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle>{aluno ? 'Editar aluno' : 'Novo aluno'}</DialogTitle>
        </DialogHeader>
        {/* `key` força remontar o form somente quando outro aluno é aberto para edição. */}
        <AlunoForm
          key={aluno?.id ?? 'novo'}
          aluno={aluno}
          materias={materias}
          onSalvo={() => {
            onOpenChange(false);
            onSalvo();
          }}
          onPersistido={onSalvo}
          onPainelAtualizado={onPainelAtualizado}
        />
      </DialogContent>
    </Dialog>
  );
}
